'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fsts = require('fsts');

var _GridStyle = require('./GridStyle');

var _GridStyle2 = _interopRequireDefault(_GridStyle);

var _GridCss = require('./GridCss');

var _GridCss2 = _interopRequireDefault(_GridCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_Component) {
    _inherits(Row, _Component);

    function Row() {
        _classCallCheck(this, Row);

        return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
    }

    _createClass(Row, [{
        key: 'render',
        value: function render() {
            var style = this.props.style;

            var styl = Object.assign({}, _GridStyle2.default.row, style);
            var p = _fsts.JS.lessProps(this.props, 'style');

            if (_fsts.Device.hasWindow()) {
                return _react2.default.createElement(
                    'div',
                    _extends({ className: 'fluid-react-row', style: styl }, p),
                    this.props.children
                );
            }

            return _react2.default.createElement(
                'div',
                _extends({ className: 'fluid-react-row', style: styl }, p),
                _react2.default.createElement(_GridCss2.default, null),
                this.props.children
            );
        }
    }]);

    return Row;
}(_react.Component);

exports.default = Row;


/*****************
 ** WEBPACK FOOTER
 ** ./~/fluid-react/dist/grid/Row.js
 ** module id = 768
 ** module chunks = 0
 **/